import {
  getSourceUrl,
  saveSolidDatasetAt,
  SolidDataset,
} from '@inrupt/solid-client'
import log from 'loglevel'
import React from 'react'
import { fetchByServer } from '../api/aggregationApi'
import { ButtonState } from '../models/ButtonState'

export function useSaveToPod() {
  const [status, setStatus] = React.useState<ButtonState>('idle')

  const handleSaveToPod = (
    dataset: SolidDataset,
    setDataset?: (d: SolidDataset) => void
  ): Promise<SolidDataset> => {
    const indexUrl = getSourceUrl(dataset)
    if (!indexUrl) {
      log.warn('no indexUrl found for surveyDataSet')
      return Promise.reject(`Could not save to pod! No sourceUrl for pod found`)
    }

    setStatus('pending')
    return saveSolidDatasetAt(indexUrl, dataset, { fetch: fetchByServer }).then(
      updatedDataset => {
        setDataset?.(updatedDataset)
        setStatus('resolved')
        return updatedDataset
      },
      () => {
        setStatus('rejected')
        throw new Error()
      }
    )
  }

  return { status, handleSaveToPod }
}
